import '@fontsource/jetbrains-mono/latin.css';
import { createTheme } from '@mantine/core';

export const theme = createTheme({
  primaryColor: 'orange',
  fontFamilyMonospace: '"JetBrains Mono", Cascadia Code, monospace',
  fontFamily: '"JetBrains Mono", Cascadia Code, monospace',
});
